import { makeAutoObservable, runInAction } from 'mobx'
import { productMobx } from 'restaurant'
import { ddayjs } from '@dt/fe-utils'
import ProductAPI from 'api/product.api'
import { uniqBy } from '@dt/fe-utils/dist/lodash'
import { MallProductAPI } from '@api/index'
import { mallProductMobx } from '@mobx/mall'

interface IHotProduct {
  /** 权重 */
  qty: number;
  /** 餐品no */
  no: string;
}

class HotProduct {
  constructor () {
    makeAutoObservable(this)
  }
  /** 当前热搜餐品 */
  hotProductList: IHotProduct[] = []

  get noToQty () {
    const noToQtyMap: { [no: string]: number } = {}
    this.hotProductList.forEach(hp => (noToQtyMap[hp.no] = hp.qty))
    return noToQtyMap
  }

  get HotViewProduct (): IViewProduct[] {
    const hotExitList: IViewProduct[] = []
    this.hotProductList.map(v => {
      const viewProduct = productMobx.noToViewProductMap[v.no]
      if (viewProduct) {
        hotExitList.push(viewProduct)
      }
    })
    return hotExitList.filter(item => item.isNotSingleInCombo && !item.isOpenPrice && item.isShowInMenu).splice(0, 8)
  }

  get HotMallViewProduct (): IMallViewProduct[] {
    const hotExitList: IMallViewProduct[] = []
    this.hotProductList.map(v => {
      const viewProduct = mallProductMobx.noToViewProductMap[v.no]
      if (viewProduct) {
        hotExitList.push(viewProduct)
      }
    })
    return hotExitList.splice(0, 8)
  }

  init () {
    const endTime = ddayjs().format('YYYY-MM-DD')
    const startTime = ddayjs().add(-7, 'day').format('YYYY-MM-DD')
    ProductAPI.getHotProduct(startTime, endTime).then((res: IHotProduct[]) => {
      if (res.length) {
        runInAction(() => {
          this.hotProductList = uniqBy(res.sort((a, b) => b.qty - a.qty), 'no')
        })
      }
    })
  }

  /** 商城热销 */
  initMall () {
    const endTime = ddayjs().format('YYYY-MM-DD')
    const startTime = ddayjs().add(-30, 'day').format('YYYY-MM-DD')
    MallProductAPI.getHotProduct(startTime, endTime, Config.BRANDID).then((res: IHotProduct[]) => {
      if (res.length) {
        runInAction(() => {
          this.hotProductList = uniqBy(res.sort((a, b) => b.qty - a.qty), 'no')
        })
      }
    })
  }
}

export default new HotProduct()
